import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ApiService} from '@drl/core/api/api.service';
import {GetListAPICommand} from '@drl/core/api/commands';
import {environment} from '@drl/env/environment';

import {PhrCategory} from '../models/phr-category.model';

export class GetPhrCategoriesCommand extends GetListAPICommand<PhrCategory> {
  constructor(apiService: ApiService, adapter: IAdapter<PhrCategory>) {
    super(apiService, adapter, `${environment.patientApiUrl}/phr-categories`);
  }
}
